import type { UserPermission, UserRole } from "@/lib/api";

/**
 * 課金ページは管理者以上に公開する (backend の BillingEndpoints.RequireBillingViewerAsync と揃える)。
 * クラウドで課金を管理する構成では、課金の閲覧権限を持つユーザーにもローカルの課金案内を公開する。
 * 実際のクラウド課金データの権限はクラウド側で判定する。
 */
export function canAccessBilling(
	role: UserRole,
	permissions: readonly UserPermission[],
	billingManagedInCloud = false,
): boolean {
	return (
		role === "Admin" ||
		role === "SuperAdmin" ||
		(billingManagedInCloud && permissions.includes("viewBilling"))
	);
}
